import HeroSection from "../components/AboutSection/HeroSection";
import TeamSection from "../components/AboutSection/TeamSection";
import StatisticHomeSection from "../components/HomeSection/StatisticHomeSection";

import personne from "../images/icons/chiffre/11.png";
import mairies from "../images/icons/chiffre/12.png";
import usine from "../images/icons/chiffre/9.png";
import eau from "../images/icons/chiffre/10.png";
function About() {
  return (
    <>
      <HeroSection />
      <TeamSection />
      <StatisticHomeSection
        className="about"
        img1={personne}
        title1="de l'eau envoyée dans le réseau arrive à l'usager"
        val1="92%"
        img2={mairies}
        title2="Unité de décarbonatation"
        val2={1}
        img3={usine}
        title3="de canalisations"
        val3={1400}
        img4={eau}
        title4="Une eau distribuée en période de gel pour éviter les casses"
        val4={8}
      />
    </>
  );
}

export default About;
